import React from 'react';
import styles from './styles.module.css';

// Using dangerouslySetInnerHTML allows the associated javascript to manipulate
// the DOM without React getting upset.

export function Twitter(): React.ReactElement {
  return (
    <span
      className={styles.button}
      dangerouslySetInnerHTML={{
        __html: `
        <a href="https://twitter.com/share" class="twitter-share-button" data-show-count="false">
          Tweet
        </a>
      `,
      }}
    />
  );
}

export function Script(): string {
  return '<script async src="//platform.twitter.com/widgets.js" charset="utf-8"></script>';
}
